export enum Axis {
  LEFT = "left",
  RIGHT = "right",
  BOTH = "both",
}
